import { useState } from 'react'
import { alertService } from '../services/AlertService';
import { handleError } from '../model/handleError';
import SurveyTemplateService from '../services/SurveyTemplateService/SurveyTemplateService';

const useSurveyTemplate = () => {
  const [loadingState, setLoadingState] = useState({
    isLoadingSurveyTemplateCreating: false,
    isLoadingSurveyTemplateDelete: false,
    isLoadingSurveyTemplateUpdate: false,
    isLoadingSurveyTemplateByIdCorso: false,
    isLoadingSurveyTemplateByIdArea: false,
    isLoadingSurveyTemplateByIdContenuto: false,
  });


  const getSurveyTemplateByIdCorso = async (id_corso) => {
    setLoadingState({ ...loadingState, isLoadingSurveyTemplateByIdCorso: true });
    try {
      let response = await SurveyTemplateService.getSurveyTemplateByIdCorso(id_corso);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSurveyTemplateByIdCorso: false });
    }
  }

  const getSurveyTemplateByIdArea = async (id_area) => {
    setLoadingState({ ...loadingState, isLoadingSurveyTemplateByIdArea: true });
    try {
      let response = await SurveyTemplateService.getSurveyTemplateByIdArea(id_area);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSurveyTemplateByIdArea: false });
    }
  }

  const getSurveyTemplateByIdContenuto = async (id_contenuto) => {
    setLoadingState({ ...loadingState, isLoadingSurveyTemplateByIdContenuto: true });
    try {
      let response = await SurveyTemplateService.getSurveyTemplateByIdContenuto(id_contenuto);
      return response;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSurveyTemplateByIdContenuto: false });
    }
  }

  const createSurveyTemplate = async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingSurveyTemplateCreating: true }));
    try {
      const response = await SurveyTemplateService.createSurveyTemplate(data);
      alertService.success("Template creato con successo", {autoClose: true});
      return response;
    } catch (error) {
      handleError(error);
      return null;
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingSurveyTemplateCreating: false }));
    }
  }

  const deleteSurveyTemplate = async (id) => {
    try {
      setLoadingState({ ...loadingState, isLoadingSurveyTemplateDelete: true });
      let response = await SurveyTemplateService.deleteSurveyTemplate(id);
      const res = await response.json();
      alertService.success("Template eliminato con successo", {autoClose: true});
      return res;
    } catch (error) {
      handleError(error)
    } finally {
      setLoadingState({ ...loadingState, isLoadingSurveyTemplateDelete: false });
    }
  }

  const updateSurveyTemplate = async (data) => {
    setLoadingState(prev => ({ ...prev, isLoadingSurveyTemplateUpdate: true }));
    try {
      const response = await SurveyTemplateService.updateSurveyTemplate(data);
      alertService.success("Template aggiornato con successo", {autoClose: true});
      return response;
    } catch (error) {
      handleError(error);
      return null;
    } finally {
      setLoadingState(prev => ({ ...prev, isLoadingSurveyTemplateUpdate: false }));
    }
  }

  return {
    createSurveyTemplate,
    loadingStateSurveyTemplate: loadingState,
    updateSurveyTemplate,
    deleteSurveyTemplate,
    getSurveyTemplateByIdCorso,
    getSurveyTemplateByIdArea,
    getSurveyTemplateByIdContenuto
  };
}

export default useSurveyTemplate;

